<span class="label custom-snackbar" [ngClass]="'snack-' + data.type" matSnackBarLabel>
  <div class="d-flex icon">
    <mat-icon>{{ getIconName(data.type) }}</mat-icon>
  </div>
  <div class="data ps-3 flex-grow-1">{{ data.message }}</div>
</span>
<span class="action custom-snackbar" [ngClass]="'snack-' + data.type" matSnackBarActions>
  <button class="close" mat-button matSnackBarAction (click)="snackBarRef.dismiss()"><mat-icon>close</mat-icon></button>
</span>
